import { Component, inject } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';
import { InHomeCareLicenseService } from 'app/services/license/in-home-care/in-home-care-license.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-in-home-care-management',
  templateUrl: './in-home-care-management.component.html',
  styleUrls: ['./in-home-care-management.component.scss']
})
export class InHomeCareManagementComponent {
  public referenceTypes: string[] = ['Empty Background Check Request', 'Policy and Procedure Memo', 'Fingerprints'];
  public ihcReference: string = 'IHCReference';

  public licenseService = inject(InHomeCareLicenseService);
  public sharedService = inject(SharedService);

  uploadData(event: Event, licenses: boolean): void {
    const files = (event.target as HTMLInputElement).files;
    if (!files || files.length === 0) {
      return;
    }
    let file = files[0];
    const formData = new FormData();
    formData.append("csv", file, file.name);

    let method: Observable<boolean>;

    if(licenses){
      method = this.licenseService.uploadIHCData(formData);
    }
    else{
      method = this.licenseService.uploadBranchData(formData);
    }

    method.subscribe({
      complete: () => {
        this.sharedService.toastr.success("Data uploaded successfully");
        (event.target as HTMLInputElement).value = '';
      },
      error: e => {
        (event.target as HTMLInputElement).value = '';
        this.sharedService.toastr.error("Could not upload document");
        console.log('Error uploading document', e);
      }
    });
  }

}
